import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

// API for creating work order for installation
export const postWorkOrderInstallation = (payload) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.post(`/workorder/addFeildIssurWorkOrderGeneration?fkUserId=${fkUserId}&role=${role}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


// API for getting list of all work order of installation
export const getWorkOrderInstallationList = ( pageNo, jobType, fkUserId, role, headers ) => {
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueList/${pageNo}?jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

// API for getting sr no of all work order of installation
export const getWorkOrderSrNo = (jobType, oprationType, customerName, headers) => {
  return Axios.get(`/workorder/getWorkOrderSerialNumber?jobType=${jobType}&oprationType=${oprationType}&customerName=${customerName}`, {
    headers,
  });
};

export const getInstallationPdfDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let fileType = ["Pdf"];
  let jobType = ["installation"];
  return Axios.get(
    `/workorder/getWorkOrderGenerationReportInPdf?fileType=${fileType}&jobType=${jobType}&fromDate=${fromDate}
    &toDate=${toDate}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `workorderinstallationreport.pdf`);
  });
};

export const getFieldWorkOrderExcelDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let fileType = ["Excel"];
  let jobType = ["installation"];
  return Axios.get(
    `/workorder/getWorkOrderGenerationReportInPdf?fileType=${fileType}&jobType=${jobType}&fromDate=${fromDate}
    &toDate=${toDate}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `workorderinstallationbetweentwodate.xlsx`);
  });
};

// API for getting list of all dispatch by from and to date
export const getInstallationEntryByDate = (pageNo, fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let jobType = ["installation"];
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueListBetweenTwoDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getFieldWorkOrderDetailsLExcel = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["installation"];
  let fileType = ["Excel"];
  return Axios.get(
    `/workorder/getFieldWorkOrderDetailsListExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
    ).then((response) => {
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileSaver.saveAs(blob, `FieldWorkOrderInstallationList.xlsx`);
    });
};

export const getFieldWorkOrderDetailsLPDF = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["installation"];
  let fileType = ["Pdf"];
  return Axios.get(
    `/workorder/getFieldWorkOrderDetailsListExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `FieldWorkOrderInstallationList.pdf`);
  });
};


export const getinstallationDispenserSerialNumber = (pageNo, dispenserSrNo) => {
  // const role = sessionStorage.getItem("role");
  // const fkUserId = sessionStorage.getItem("pkUserId");
  const token = sessionStorage.getItem("token");
  const jobType = ["installation"];

  // console.log('Role:', role, 'FkUserId:', fkUserId, 'Dispenser Serial Number:', dispenserSrNo,"jobType",jobType);

  const url = `/workorder/getJobAssignmentsByDispenserAndJobType/${pageNo}?dispenserSrNo=${dispenserSrNo}&jobType=${jobType}`;

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};


